import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import VideoCard from './VideoCard';
import styles from './VideoOverview.module.css';
import LoadingRing from '../ui-components/LoadingRing';
import {
    getDepartmentVideos,
    getPublishedVideos,
} from '../../services/apiService';
import AuthContext, { StoredContext } from './../../store/auth-context';
import RIGHTS_KEYS from './../../constants/rights-keys.js';
import Button, { ButtonType } from '../general-components/Button';
import PERMISSION_KEYS from '../../constants/permission-keys';

const VideoOverview = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [videoList, setVideoList] = useState([]);
    const context = useContext(AuthContext);
    let ctx: StoredContext = context.getContext();

    const navigate = useNavigate();

    const getData = async () => {
        setIsLoading(true);

        const videos = await getDepartmentVideos();

        setVideoList(videos);
        setIsLoading(false);
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.videoFlexRow}>
                <div>
                    <h1>{t('videoOverview.videoOverview.title')}</h1>
                </div>
                {ctx.isLoggedIn &&
                    context.hasPermission(PERMISSION_KEYS.manageFiles) && (
                        <Button
                            type={ButtonType.primary}
                            onClick={() => {
                                navigate('/video-upload');
                            }}
                        >
                            {t(
                                'videoOverview.videoOverview.buttons.uploadVideo'
                            )}
                        </Button>
                    )}
            </div>

            {!isLoading && videoList.length === 0 && (
                <h3>{t('videoOverview.videoOverview.emptyState.noVideos')}</h3>
            )}
            {isLoading && (
                <div className={styles.loading}>
                    <LoadingRing size="large" />
                </div>
            )}
            {!isLoading && videoList.length !== 0 && (
                <div className={styles.videosWrapper}>
                    {videoList?.map((video) => (
                        <VideoCard key={video._id} video={video} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default VideoOverview;
